module.exports={TICKET:{STARTING_FROM:"Tickets kaufen"},MASONRY:{SEARCH:{CATEGORIES:"KATEGORIEN"}}};